var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"link-sub-list-item",attrs:{"to":_vm.path}},[_c('div',{staticClass:"title-and-desc"},[_vm._t("default")],2),_vm._t("icon-after",function(){return [_c('BaseIcon',{staticClass:"chevron-icon",attrs:{"icon-file":'chevron-right-dark2',"width":20,"height":20}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }